import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";

import Banners from './Banners.tsx';
import {NavbarTop} from './NavbarTop.tsx'
import {Message} from "../messages/Message.tsx";
import {FlowerFeastHeader} from "../flower_feast/FlowerFeastHeader";

interface HeaderInterface {
    toggleMenu: Function,
}

export const Header = ({toggleMenu}: HeaderInterface) => {
  return (
    <>
      <NavbarTop toggleMenu={toggleMenu} />

      <Container id="layout-header" fluid className="header">
        <Row className="no-gutters d-print-none">
          <Message />
          <Banners />
        </Row>
      </Container>
        <Container fluid>
            <Row>
                <Col>
                    <FlowerFeastHeader />
                </Col>
            </Row>
        </Container>
    </>
  )
}
